import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-paginator2',
  templateUrl: './paginator2.component.html',
  styleUrls: ['./paginator2.component.scss']
})
export class Paginator2Component implements OnInit {
  @Input() number_page: number;
  @Input() size_page: number;
  @Output() eventEmmiterChangePage: EventEmitter<number> = new EventEmitter<number>();
  @Input() total = 0;
  @Input() pages_total: number;
  @Input() totalElements: number;
  pages: number[] = [];
  pages_totales: number[] = [];
  constructor() {
    this.number_page = 1;

  }

  ngAfterViewInit() {


  }
  ngOnInit(): void {


  }
  ngOnChanges(changes: any) {
    this.pages_totales = Array.from({ length: this.pages_total }, (_, i) => i + 1);
    this.move(this.number_page);
  }

  move(number_page: number) {
    let maxPagesToShow = 5;
    let half = Math.floor(maxPagesToShow / 2);
  
    if (this.pages_total <= 1) {
      // Si solo hay una página, solo mostrar [1]
      this.pages = [1];
      return;
    }
  
    let start = Math.max(1, number_page - half);
    let end = Math.min(this.pages_total, start + maxPagesToShow - 1);
  
    // Ajuste si estamos cerca del final
    if (end - start < maxPagesToShow - 1) {
      start = Math.max(1, end - maxPagesToShow + 1);
    }
  
    this.pages = this.pages_totales.slice(start - 1, end);
  }
  
  previus() {
    if (this.number_page > 1) {
      this.number_page = this.number_page - 1;
      this.eventEmmiterChangePage.emit(this.number_page);
      this.move(this.number_page);
    }

  }

  next() {
    if (this.number_page < this.pages_total) {
      this.number_page = this.number_page + 1;
      this.eventEmmiterChangePage.emit(this.number_page);
      this.move(this.number_page);
    }
  }
  cambiarPagina(number_page) {
    this.number_page = number_page;
    this.eventEmmiterChangePage.emit(this.number_page);
    this.move(this.number_page);

  }
  first() {
    this.number_page = 1;
    this.eventEmmiterChangePage.emit(this.number_page);
    this.move(this.number_page);



  }
  last() {
    this.number_page = this.pages_total;
    this.eventEmmiterChangePage.emit(this.number_page);
    this.move(this.number_page - 3);

  }
}
